import { showNotify } from "vendor/application/disptach";
import { handlePhrasesParams } from "vendor/application";
import { hasSegmentErrors } from "utils/segmentValidation";
import { validExtensions } from "./validExtensions";
import { getUpdatedPayload } from "../Integrations/helpers/getUpdatedPayload";
import { isPayloadValid } from "../Integrations/helpers/isPayloadValid";
import { prepareExtensions } from "../Integrations/helpers/prepareExtensions";
import { sanitizeIntent } from "../Integrations/helpers/sanitizeIntent";
import { sendIntent } from "../Integrations/helpers/sendIntent";
import { validateDesk } from "../Integrations/helpers/validateDesk";

export const createIntent = async (params) => {
  const {
    intent,
    variables,
    access,
    actualProject,
    user,
    device_id,
    handleAddVariables,
    handleAddEquivalences,
    dispatch,
    props,
    returnToList,
  } = params;

  const updatedPayload = getUpdatedPayload(intent);
  const rawPayload = intent.extensions.body?.payload;
  const payload = (() => {
    if (typeof updatedPayload === "string" && updatedPayload.trim() !== "") {
      return updatedPayload;
    }
    if (typeof rawPayload === "object" && Object.keys(rawPayload).length === 0) {
      return "{}";
    }
    return rawPayload;
  })();

  if (!validExtensions(variables, dispatch)) return;

  if (hasSegmentErrors(intent)) {
    dispatch(showNotify({ message: "response_segment_too_long", severity: "error" }));
    return;
  }

  prepareExtensions(
    intent,
    variables,
    handleAddVariables,
    handleAddEquivalences
  );

  if (!isPayloadValid(intent, payload)) {
    dispatch(
      showNotify({
        message: "extension_body_has_an_invalid_value",
        severity: "error",
      })
    );
    return;
  }

  if (!handlePhrasesParams(intent, dispatch)) return;

  const send_intent = sanitizeIntent(intent, variables);

  if (!validateDesk(send_intent, dispatch)) return;

  await sendIntent(
    send_intent,
    access,
    actualProject,
    props,
    device_id,
    user,
    dispatch,
    returnToList
  );
};
